module.exports = " <div class=ProgressBlocks> <div class=ProgressBlocks-title><slot></slot>:</div> <div class=ProgressBlock v-for=\"lesson in lessons\" track-by=$index :class=\"{\n    'is-done': lesson.done,\n    'is-active': lesson.active\n  }\"> {{ lesson.index + 1}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ProgressBlocks.vue
// module id = 125
// module chunks = 2